import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../config/firebase";
import { Link } from "react-router-dom";
import "./Blogs.css";

function Blogs() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      const snapshot = await getDocs(collection(db, "blogs"));
      const blogList = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      setBlogs(blogList.sort((a, b) => b.postDate.seconds - a.postDate.seconds)); // latest first
    };
    fetchBlogs();
  }, []);

  return (
    <div className="blogs-page">
      {/* ----- Hero Section ----- */}
      <div className="blogs-hero">
        <h1>Our Blogs</h1>
        <p>
          Stay updated with the latest articles, news, and insights from our team.
          Explore topics, tips, and guides that help you stay informed.
        </p>
        <div className="filter-bar">
          <span>Latest</span> • <span>Categories</span> • <span>Popular</span>
        </div>
      </div>

      {/* ----- Blog Grid ----- */}
      <div className="blog-grid">
        {blogs.map((b) => (
          <div className="blog-card" key={b.id}>
            <img
              src={b.image}
              alt={b.title}
              className="blog-thumbnail"
            />
            <div className="blog-content">
              <h3>{b.title}</h3>
              <p
                className="excerpt"
                dangerouslySetInnerHTML={{
                  __html:
                    b.description.slice(0, 150) + "...",
                }}
              ></p>
              <Link to={`/blogs/${b.slug}`} className="read-more">
                Read More →
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Blogs;